export const DO_CLICK_ACTIONS = {
    CLOSE: "close",
    DONE: "done",
    HELP: "help",
    BANNER: "banner",
    DOWNLOAD_CTA: "click-download-cta-post-table-booking",
    CUSTOM_TIP: "custom-tip",
    ADD_TIP: "add-tip",
    NEXT: "next",
    CLEAR_TIP: "clear-tip",
    TIP_PREDEFINED: "click-tip-amount-predefined",
    CUSTOM_TIP_CLICK: "click-tip-amount-custom",
    ADD_TIP_CLICK: "add-tip-click",
    BOOKING_DETAILS: "booking-details",
    DEAL_DETAIL: "deal-detail",
    DONE_CLICK: "done-click",
    SHARE_ICON: "share-click",
    BOOKING_DETAIL: "click-booking-detail",
    BACK_BUTTON: "go-back",
    TABLE_RESERVED: "table_reserved",
    DEAL_DETAILS: "deal-detail",
    SPLIT_BILL_WIDGET: "split-bill-widget",
    SPLIT_METHOD_TAB_CLICK: "split-method-tab-click",
    SPLIT_ADD_MORE_GUEST: "split-add-more-guest",
    SPLIT_CONFIRM_CTA: "split-confirm-cta",
    SPLIT_EQUALLY: "split-equally",
    SPLIT_UPI_ENTRY: "split-upi-entry",
    SPLIT_DONE_CTA: "done-cta",
};

export const DO_IMPRESSION_ACTIONS = {
    PAYMENT_SUCCESS: "impression-do-payment-success",
    BANNER_IMPRESSION: "impression-do-payment-success-banner",
    SAVINGS_IMPRESSION: "impression-savings-impression",
    BOOKING_SUCCESS: "impression-do-booking-success",
    BILL_DETAILS: "impression-bill-details",
    DOWNLOAD_CTA: "impression-download-cta-post-table-booking",
    BOOKING_DETAILS: "booking-details",
    QR_CODE: "qr-view",
    BILL_DETAILS_EVENT: "bill-details",
    BENEFIT_CALLOUT: "impression-benefit-callout",
    IMPRESSION_YOUR_BOOKINGS: "your-bookings",
    IMPRESSION_TABLE_RESERVED: "reserved-table",
    IMPRESSION_BOOKING_CARD: "booking-card",
    IMPRESSION_DEAL_DETAILS: "deal-detail",
    CASHBACK_BENEFIT_CALLOUT: "cashback-benefit-callout",
    SPLIT_BILL_WIDGET: "split-bill-widget",
    SPLIT_METHOD_TAB: "split-method-tab",
    SPLIT_ERROR: "split-error",
    SPLIT_SUCCESS_WIDGET: "success-widget",
    DINECASH_POOL_BANNER: "impression-dinecash-pool-banner",
};

export const IMPRESSION_LABELS = {
    QR_VIEW: "qr-view",
    BILL_DETAILS: "bill-details",
    EVENT_NUDGE_IMPRESSION: "event-nudge-impression",
    YOUR_BOOKINGS: "your-bookings",
    TABLE_RESERVED: "table_reserved",
    BOOKING_CARD: "booking-card-view",
    CASHBACK_BENEFIT_CALLOUT: "cashback-benefit-callout",
};

export const CLICK_LABELS = {
    DONE_CLICK: "done-click",
    SHARE_CLICK: "share-click",
    EVENT_NUDGE_CLICK: "event-nudge-click",
    TOR_CLICK: "tor-click",
    CANCEL_BOOKING_CTA_CLICK: "cancel-booking",
    BOOKING_TICKET_CTA_CLICK: "booking-ticket-cta-click",
    MAPS_CLICK: "maps-click",
    CANCEL_BOOKING_POPUP: "cancel-booking-pop-up",
    CALL_RESTAURANT_CLICK: "call-restaurant-click",
    TNC_CLICK: "tnc-click",
    VIEW_RESTAURANT_DETAILS_CLICK: "view-restaurant-details-click",
    BACK_BUTTON: "back-click",
};
